const showMore = document.querySelector('.sidebar-title ');
const categories = document.querySelector('.sidebar-categories');

if (showMore && categories) {
  showMore.addEventListener('click', () => {
    categories.classList.toggle('sidebar-categories--active');
  });
}
